<script>
  import { getContext } from "svelte";
  import { page } from '$app/state';
  import { has_access } from '#lib/util.js';
  import ButtonLabel from '#lib/ButtonLabel.svelte';
  let entry_api = getContext("entry_api");
  let site_settings = getContext("site_settings");
  
  import t from "#lib/i18n.svelte.js";

  let {
    class: css_class 
  } = $props()

  let is_disabled = $derived(
    !has_access('member', page.data.current_user?.role) || entry_api?.is_processing
  );

  function onkeydown(e) {
    if (e.key === 's' && e.metaKey) {
      if (entry_api?.is_disabled || entry_api?.is_processing) return;
      e.preventDefault();
      entry_api.save();
    }
  }
</script>


<button
  class='save-tool {css_class}'
  class:is-processing={entry_api?.show_processing}
  onclick={() => entry_api.save()}
  disabled={is_disabled}
  style='--button-outer-block-spacing: var(--default-button-outer-block-spacing)'
>
  <ButtonLabel
    variant='brand encased text-compact'
  >
    {#if entry_api?.show_processing}
      {t('saving')}
    {:else if !entry_api.entry.entry_id && entry_api.entry.visibility === 'public'}
      {t('publish')}
    {:else}
      {t('save')}
    {/if}
  </ButtonLabel>
</button>

<svelte:window {onkeydown} />